<template>
  <v-row class="ma-10 elevation-5 fill-height" justify="space-around">
    <v-card class="ma-10" width="100%" flat tile>
      <v-card-title>
        <h3 class="text-h4">Categories</h3>
        <v-spacer></v-spacer>
        <v-btn
          class="mb-auto mr-3"
          @click.prevent="toggleAdvanceSearch"
          dark
          fab
          color="secondary"
        >
          <v-icon>mdi-magnify</v-icon></v-btn
        >
        <v-dialog v-if="modelPermissions.create" persistent v-model="dialog">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mb-auto"
              dark
              fab
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon></v-btn
            >
          </template>
          <category-dialog
            v-if="dialog"
            :categories="categories"
            :item="item"
            :close="close"
          ></category-dialog>
        </v-dialog>
      </v-card-title>

      <v-data-table
        :server-items-length="categories.total"
        :loading="loading"
        :headers="headers"
        :items="categories.data"
        :options.sync="options"
        :items-per-page="10"
      >
        <template v-slot:top>
          <v-expansion-panels disabled multiple v-model="advanceSearch" flat>
            <v-expansion-panel v-for="(item, i) in 1" :key="i">
              <v-expansion-panel-content>
                <v-row>
                  <v-toolbar flat>
                    <v-text-field
                      clear-icon
                      clearable
                      v-model.lazy="search"
                      prepend-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                    ></v-text-field>
                  </v-toolbar>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
        <template v-if="modelPermissions.edit" v-slot:item.edit="{ item }">
          <v-btn text @click="editItem(item)" color="primary">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-if="modelPermissions.delete" v-slot:item.delete="{ item }">
          <v-btn text @click="deleteItem(item)" color="error">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-row>
</template>

<script>
import CategoryDialog from './CategoryDialog'
import axios from '../../../utils/axios'
import { mapGetters } from 'vuex'
export default {
  name: 'CategoryIndex',
  components: {
    CategoryDialog
  },
  data() {
    return {
      advanceSearch: [],
      dialog: false,
      loading: false,
      headers: [
        {
          text: 'Category',
          align: 'start',
          value: 'name'
        },
        { text: 'Edit', align: 'center', value: 'edit', sortable: false },
        { text: 'Delete', align: 'center', value: 'delete', sortable: false }
      ],

      categories: [],
      options: {},
      item: {},
      search: ''
    }
  },
  methods: {
    toggleAdvanceSearch() {
      if (this.advanceSearch.length === 1) {
        this.advanceSearch = []
        // this.category = ''
        // this.suburb = ''
      } else {
        this.advanceSearch = [0]
      }
    },
    close() {
      this.item = {}
      this.dialog = false
    },
    editItem(item) {
      this.item = item
      this.dialog = true
    },
    getCategories() {
      this.loading = true
      console.log('getting categories')
      axios
        .get(
          `api/admin/categories?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}&search=${this.search}`
        )
        .then(res => {
          this.categories = res.data
          this.loading = false
          console.log('done')
        })
    },
    deleteItem(item) {
      if (confirm(`Confirm Delete...${item.name}`)) {
        console.log('deleting category with id ', item.id)
        axios
          .delete(`api/admin/categories/${item.id}`)
          .then(res => {
            console.log(res)
            if (res.data === 1) {
              this.getCategories()
            }
          })
          .catch(err => console.log(err))
      }
    }
  },
  computed: {
    ...mapGetters(['permissions/getModelPermissions']),
    modelPermissions() {
      return this['permissions/getModelPermissions']('category')
    }
  },
  watch: {
    options: {
      handler() {
        this.getCategories()
      },
      deep: true
    },
    dialog: {
      handler() {
        this.getCategories()
      },
      deep: true
    },
    search: {
      handler() {
        this.getCategories()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
